module.exports = __webpack_public_path__ + "img/首页banner.e186b0d9.png";